export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets100_strips150_cuff_gray@2x.baded30f.jpg";